<template>
  <div class="jump-item">
    <el-link type="primary" @click.native="jumpToBreak(source)">
      {{ source.transactionId }} —
      {{ $dayjs(source.createdAt).format("DD.MM.YYYY HH:mm:ss") }}
    </el-link>
  </div>
</template>
<script>
export default {
  name: "FullBalanceLegacyGapItem",
  props: {
    index: {
      type: Number
    },
    source: {
      type: Object,
      required: true
    },
    jumpToBreak: {
      type: Function,
      default: () => {}
    }
  }
};
</script>
<style scoped>
.jump-item {
  padding: 4px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Ledger/components/FullBalance/LegacyGapItem.vue